// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ToursRouteImport } from './routes/tours'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PetPolicyRouteImport } from './routes/pet-policy'
import { Route as OutdoorGlampingEventsRouteImport } from './routes/outdoor-glamping-events'
import { Route as OnsiteExperiencesRouteImport } from './routes/onsite-experiences'
import { Route as OffersRouteImport } from './routes/offers'
import { Route as NearbyExperiencesRouteImport } from './routes/nearby-experiences'
import { Route as MandatoryDrivingInstructionsRouteImport } from './routes/mandatory-driving-instructions'
import { Route as LuxuryTentedLodgingRouteImport } from './routes/luxury-tented-lodging'
import { Route as LuxuryCorporateRetreatsRouteImport } from './routes/luxury-corporate-retreats'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InfoRouteImport } from './routes/info'
import { Route as GlampingWeddingVenueRouteImport } from './routes/glamping-wedding-venue'
import { Route as GlampingForLargeGroupsRouteImport } from './routes/glamping-for-large-groups'
import { Route as GlampingFamilyReunionsRouteImport } from './routes/glamping-family-reunions'
import { Route as GlampingActivitiesAndAmenitiesRouteImport } from './routes/glamping-activities-and-amenities'
import { Route as GettingHereRouteImport } from './routes/getting-here'
import { Route as FamilyRouteImport } from './routes/family'
import { Route as EnhanceRouteImport } from './routes/enhance'
import { Route as CulinaryRouteImport } from './routes/culinary'
import { Route as CouplesRouteImport } from './routes/couples'
import { Route as BookRouteImport } from './routes/book'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as ESlugRouteImport } from './routes/e.$slug'
import { Route as CSlugRouteImport } from './routes/c.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as PPathSlugRouteImport } from './routes/p.$path.$slug'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminThingsToDoRouteImport } from './routes/_authenticated/admin.things-to-do'
import { Route as AuthenticatedAdminSuitesRouteImport } from './routes/_authenticated/admin.suites'
import { Route as AuthenticatedAdminIntroRouteImport } from './routes/_authenticated/admin.intro'
import { Route as AuthenticatedAdminGroupsEventsRouteImport } from './routes/_authenticated/admin.groups-events'
import { Route as AuthenticatedAdminEnhancementsRouteImport } from './routes/_authenticated/admin.enhancements'
import { Route as AuthenticatedAdminCulinaryRouteImport } from './routes/_authenticated/admin.culinary'
import { Route as AuthenticatedAdminBlogRouteImport } from './routes/_authenticated/admin.blog'

const ToursRoute = ToursRouteImport.update({
            id: '/tours',path: '/tours',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PetPolicyRoute = PetPolicyRouteImport.update({
            id: '/pet-policy',path: '/pet-policy',getParentRoute: () => rootRouteImport
          })
const OutdoorGlampingEventsRoute = OutdoorGlampingEventsRouteImport.update({
            id: '/outdoor-glamping-events',path: '/outdoor-glamping-events',getParentRoute: () => rootRouteImport
          })
const OnsiteExperiencesRoute = OnsiteExperiencesRouteImport.update({
            id: '/onsite-experiences',path: '/onsite-experiences',getParentRoute: () => rootRouteImport
          })
const OffersRoute = OffersRouteImport.update({
            id: '/offers',path: '/offers',getParentRoute: () => rootRouteImport
          })
const NearbyExperiencesRoute = NearbyExperiencesRouteImport.update({
            id: '/nearby-experiences',path: '/nearby-experiences',getParentRoute: () => rootRouteImport
          })
const MandatoryDrivingInstructionsRoute = MandatoryDrivingInstructionsRouteImport.update({
            id: '/mandatory-driving-instructions',path: '/mandatory-driving-instructions',getParentRoute: () => rootRouteImport
          })
const LuxuryTentedLodgingRoute = LuxuryTentedLodgingRouteImport.update({
            id: '/luxury-tented-lodging',path: '/luxury-tented-lodging',getParentRoute: () => rootRouteImport
          })
const LuxuryCorporateRetreatsRoute = LuxuryCorporateRetreatsRouteImport.update({
            id: '/luxury-corporate-retreats',path: '/luxury-corporate-retreats',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const InfoRoute = InfoRouteImport.update({
            id: '/info',path: '/info',getParentRoute: () => rootRouteImport
          })
const GlampingWeddingVenueRoute = GlampingWeddingVenueRouteImport.update({
            id: '/glamping-wedding-venue',path: '/glamping-wedding-venue',getParentRoute: () => rootRouteImport
          })
const GlampingForLargeGroupsRoute = GlampingForLargeGroupsRouteImport.update({
            id: '/glamping-for-large-groups',path: '/glamping-for-large-groups',getParentRoute: () => rootRouteImport
          })
const GlampingFamilyReunionsRoute = GlampingFamilyReunionsRouteImport.update({
            id: '/glamping-family-reunions',path: '/glamping-family-reunions',getParentRoute: () => rootRouteImport
          })
const GlampingActivitiesAndAmenitiesRoute = GlampingActivitiesAndAmenitiesRouteImport.update({
            id: '/glamping-activities-and-amenities',path: '/glamping-activities-and-amenities',getParentRoute: () => rootRouteImport
          })
const GettingHereRoute = GettingHereRouteImport.update({
            id: '/getting-here',path: '/getting-here',getParentRoute: () => rootRouteImport
          })
const FamilyRoute = FamilyRouteImport.update({
            id: '/family',path: '/family',getParentRoute: () => rootRouteImport
          })
const EnhanceRoute = EnhanceRouteImport.update({
            id: '/enhance',path: '/enhance',getParentRoute: () => rootRouteImport
          })
const CulinaryRoute = CulinaryRouteImport.update({
            id: '/culinary',path: '/culinary',getParentRoute: () => rootRouteImport
          })
const CouplesRoute = CouplesRouteImport.update({
            id: '/couples',path: '/couples',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const ESlugRoute = ESlugRouteImport.update({
            id: '/e/$slug',path: '/e/$slug',getParentRoute: () => rootRouteImport
          })
const CSlugRoute = CSlugRouteImport.update({
            id: '/c/$slug',path: '/c/$slug',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRoute
          })
const PPathSlugRoute = PPathSlugRouteImport.update({
            id: '/p/$path/$slug',path: '/p/$path/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminThingsToDoRoute = AuthenticatedAdminThingsToDoRouteImport.update({
            id: '/things-to-do',path: '/things-to-do',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSuitesRoute = AuthenticatedAdminSuitesRouteImport.update({
            id: '/suites',path: '/suites',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminIntroRoute = AuthenticatedAdminIntroRouteImport.update({
            id: '/intro',path: '/intro',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminGroupsEventsRoute = AuthenticatedAdminGroupsEventsRouteImport.update({
            id: '/groups-events',path: '/groups-events',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminEnhancementsRoute = AuthenticatedAdminEnhancementsRouteImport.update({
            id: '/enhancements',path: '/enhancements',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCulinaryRoute = AuthenticatedAdminCulinaryRouteImport.update({
            id: '/culinary',path: '/culinary',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminBlogRoute = AuthenticatedAdminBlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => AuthenticatedAdminRoute
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminBlogRoute: AuthenticatedAdminBlogRoute,AuthenticatedAdminCulinaryRoute: AuthenticatedAdminCulinaryRoute,AuthenticatedAdminEnhancementsRoute: AuthenticatedAdminEnhancementsRoute,AuthenticatedAdminGroupsEventsRoute: AuthenticatedAdminGroupsEventsRoute,AuthenticatedAdminIntroRoute: AuthenticatedAdminIntroRoute,AuthenticatedAdminSuitesRoute: AuthenticatedAdminSuitesRoute,AuthenticatedAdminThingsToDoRoute: AuthenticatedAdminThingsToDoRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,BookRoute: BookRoute,CouplesRoute: CouplesRoute,CulinaryRoute: CulinaryRoute,EnhanceRoute: EnhanceRoute,FamilyRoute: FamilyRoute,GettingHereRoute: GettingHereRoute,GlampingActivitiesAndAmenitiesRoute: GlampingActivitiesAndAmenitiesRoute,GlampingFamilyReunionsRoute: GlampingFamilyReunionsRoute,GlampingForLargeGroupsRoute: GlampingForLargeGroupsRoute,GlampingWeddingVenueRoute: GlampingWeddingVenueRoute,InfoRoute: InfoRoute,LoginRoute: LoginRoute,LuxuryCorporateRetreatsRoute: LuxuryCorporateRetreatsRoute,LuxuryTentedLodgingRoute: LuxuryTentedLodgingRoute,MandatoryDrivingInstructionsRoute: MandatoryDrivingInstructionsRoute,NearbyExperiencesRoute: NearbyExperiencesRoute,OffersRoute: OffersRoute,OnsiteExperiencesRoute: OnsiteExperiencesRoute,OutdoorGlampingEventsRoute: OutdoorGlampingEventsRoute,PetPolicyRoute: PetPolicyRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,ToursRoute: ToursRoute,BlogSlugRoute: BlogSlugRoute,CSlugRoute: CSlugRoute,ESlugRoute: ESlugRoute,BlogIndexRoute: BlogIndexRoute,PPathSlugRoute: PPathSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)